import { postRequest } from "../../../services/RestServices";
import * as urls from "../../api/C4S Decommission - Replacement/url";

export const ATPCheck = async (data) => {
  try {
    return await postRequest(urls.ATP_CHECK, data);
  } catch (err) {
    return err;
  }
};
